import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { EXACT_CATEGORIES, ExactCategory } from "models";

export type UnlinkedExactLicensesDashboardFilters = {
  ignored: boolean | null;
  exact_category_types: EXACT_CATEGORIES[] | [];
};

const component = "UnlinkedExactLicenses";

export const UnlinkedExactLicensesQueryKeys = {
  filters: localQueryKey<UnlinkedExactLicensesDashboardFilters>({ component, data: "unlinkedExactLicensesFilter" }),
  unlinkedExactCategories: backendQueryKey<ExactCategory[]>({ component, baseUrl: ENV.exactBaseURL, endpoint: "/licenses/unlinked/list" })
};
